import { render } from "./VideoChat.vue?vue&type=template&id=125d0eb0"
import script from "./VideoChat.vue?vue&type=script&lang=js"
export * from "./VideoChat.vue?vue&type=script&lang=js"

import "./VideoChat.vue?vue&type=style&index=0&id=125d0eb0&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__